import { PaginationQueryObject, QueryConfig } from "./Queries";
import { Metadata } from "../../routeComponents/Metadata/Metadata";

export const ssoIncomingListQuery = (
  filter: any,
  pagination: PaginationQueryObject
): QueryConfig => {
  const query = `query getSSOIncomingList($filter: SSOIncomingFilter, $pagination: PaginationInput) {
            SSOIncomings(filter: $filter, paginationInput: $pagination) {
                items { id, entityId, ssoURL, customer { name }},
                pageInfo { pageSize, pageNumber, totalElements, totalPages, hasNext, hasPrevious }
            }
        }`;
  return {
    query: query,
    variables: {
      filter: filter,
      pagination: pagination,
    },
  };
};

export const ssoIncomingItemQuery = (id: string): QueryConfig => {
  const query = `query getSSOIncomingItem($id: ID!) {
            SSOIncoming(id: $id) {
                id
                entityId
                x509Cert
                ssoLogOutBinding
                ssoURL
                ssoLogOutURL
                jitEnabled
                customer { id, name }
            }
        }`;
  return {
    query: query,
    variables: {
      id,
    },
  };
};

export const deleteSSOIncomingMutation = (id: string): QueryConfig => {
  const query = `mutation handleDeleteSSOIncoming($input: SSOIncomingDeleteInput!) {
            deleteSSOIncoming(input: $input)
        }`;
  return {
    query: query,
    variables: {
      input: {
        id: id,
      },
    },
  };
};

export const updateSSOIncomingMutation = (
  id: string,
  ssoIncoming: Metadata
): QueryConfig => {
  const query = `mutation handleUpdateSSOIncoming($input: SSOIncomingUpdateInput!) {
            updateSSOIncoming(input: $input) { id } 
        }`;
  return {
    query: query,
    variables: {
      input: {
        id: id,
        x509Cert: ssoIncoming.x509Cert,
        ssoLogOutBinding: ssoIncoming.ssoLogOutBinding,
        ssoLogOutURL: ssoIncoming.ssoLogOutURL,
        ssoURL: ssoIncoming.ssoURL,
        jitEnabled: ssoIncoming.jitEnabled,
      },
    },
  };
};

export const createSSOIncomingMutation = (
  ssoIncoming: Metadata
): QueryConfig => {
  const query = `mutation handleCreateSSOIncoming($input: SSOIncomingCreateInput!) {
            createSSOIncoming(input: $input) { id }
        }`;
  return {
    query: query,
    variables: {
      input: {
        entityId: ssoIncoming.entityId,
        x509Cert: ssoIncoming.x509Cert,
        customerId: ssoIncoming.customerid,
        ssoLogOutBinding: ssoIncoming.ssoLogOutBinding,
        ssoLogOutURL: ssoIncoming.ssoLogOutURL,
        ssoURL: ssoIncoming.ssoURL,
        jitEnabled: ssoIncoming.jitEnabled,
      },
    },
  };
};
